import React, { useEffect, useState } from 'react'
import Header from '../components/Header'
import Leftmenu from '../components/Leftmenu'
import Rightmenu from '../components/Rightmenu'
import NotificationCard from '../components/NotificationCard'
import { useOutletContext } from "react-router-dom";

function Notification() {
      const [notifications, setNotifications] = useState([]);
      const {user, token} = useOutletContext();

     const getNotifications = () => {
                      fetch('/api/get-notifications',{
                          method: "POST",
                          headers: {
                              Authorization: `Bearer ${token}`,
                          },
                      }).then((response) => response.json())
                      .then((data) => {
                          if (data.extraerror) {
                              console.log(data.extraerror);
                          }
                          else if(data.data && data.message) {
                             
                              setNotifications(data.data);
                     
                             
                          }
                      })
                  }
        useEffect(() => {
            getNotifications();
        },[]);
  return (
    <div>
        <Header />
        <Leftmenu />
        <Rightmenu />
<div className="main-content right-chat-active">
  <div className="middle-sidebar-bottom">
    <div className="middle-sidebar-left pe-0 ps-lg-3 ms-0 me-0" style={{maxWidth: '100%'}}>
      <div className="row">
        <div className="col-lg-12">
          <div class="card shadow-xss w-100 d-block d-flex border-0 p-4 mb-3"><div class="card-body d-flex align-items-center p-0"><h2 class="fw-700 mb-0 mt-0 font-md text-grey-900">Notifications</h2></div></div>
          <div className="chat-wrapper p-3 w-100 position-relative scroll-bar bg-white theme-dark-bg">
            <ul className="email-message">
                {notifications.length > 0 && notifications.map((notification) => (
                    <NotificationCard notification={notification} key={notification.id} />
                ))}
           
            
            </ul>                                 
          </div>
        </div>
      </div>
    </div>
  </div>            
</div>

        </div>
  )
}

export default Notification